import client from './client';

export async function startGame(playerName) {
  const response = await client.post('/play/start', { player_name: playerName });
  return response.data;
}

export async function getGame(code) {
  const response = await client.get(`/play/${code}`);
  return response.data;
}

export async function selectBox(code, boxNumber) {
  const response = await client.post(`/play/${code}/select-box`, { box_number: boxNumber });
  return response.data;
}

export async function openBox(code, boxNumber) {
  const response = await client.post(`/play/${code}/open-box`, { box_number: boxNumber });
  return response.data;
}

export async function respondOffer(code, accepted, swap = false, swapBoxNumber = null) {
  const response = await client.post(`/play/${code}/offer/respond`, {
    accepted,
    swap,
    swap_box_number: swapBoxNumber,
  });
  return response.data;
}

export async function completeGame(code) {
  const response = await client.post(`/play/${code}/complete`);
  return response.data;
}
